import { useQuery } from 'react-query';
import QUERY_CACHE_KEY from '@src/constants/QueryCacheKey';

function useResourcesQuery(options) {
  return useQuery(QUERY_CACHE_KEY.resources(), options);
}

export default useResourcesQuery;
